export default {
    url: '/finished',
    template: '<survey-public-survey-finished form-submission="vm.formSubmission" survey-group="vm.surveyGroup"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form' }).$promise;
        }
    },
    controller (formSubmission, surveyGroup) {
        this.formSubmission = formSubmission;
        this.surveyGroup = surveyGroup;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/survey/survey/finished/index.js